var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.486,
    height: 20.96,
    viewBox: "0 0 61.486 20.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -20.782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.486,15.12v5.84H0V15.12H18.379L5.472,0H15.23L30.717,18.24,46.257,0h9.757L43.107,15.12Z",
    transform: "translate(32 20.782)",
    fill: "#f7931a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.831991a16d72e6dd9ffde08a34c22422.svg";
export { ForwardRef as ReactComponent };